<!--=================================
=            TRANSITIONS            =
==================================-->
<template>
  <v-container >
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Transition</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">Slide X transitions

            <div class="textt"></div>
          </div>
          <div slot="card-body">

            <v-row justify="center">
              <v-menu transition="slide-x-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="purple" class="ma-2 white--text" v-on="on">
                    Slide X Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div class="mx-4 hidden-sm-and-down"></div>

              <v-menu transition="slide-x-reverse-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="teal" class="ma-2 white--text" v-on="on">
                    Slide X Reverse Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>

          </div>
        </base-card>

      </v-col>

      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">Slide Y transitions

            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row justify="center">
              <v-menu transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="purple" class="ma-2 white--text" v-on="on">
                    Slide Y Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div class="mx-4 hidden-sm-and-down"></div>

              <v-menu transition="slide-y-reverse-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="teal" class="ma-2 white--text" v-on="on">
                    Slide Y Reverse Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </div>
        </base-card>

      </v-col>


      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">Scroll X transitions

            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row justify="center">
              <v-menu transition="scroll-x-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="purple" class="ma-2 white--text" v-on="on">
                    Scroll X Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div class="mx-4 hidden-sm-and-down"></div>

              <v-menu transition="scroll-x-reverse-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="teal" class="ma-2 white--text" v-on="on">
                    Scroll X Reverse Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </div>
        </base-card>

      </v-col>

      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">
            Fade Transition
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="text-center">
              <v-menu transition="fade-transition">
                <template v-slot:activator="{ on }">
                  <v-btn dark color="purple" v-on="on">
                    Fade Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n">
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </base-card>

      </v-col>
      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">Scroll Y transitions

            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <v-row justify="center">
              <v-menu transition="scroll-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="purple" class="ma-2 white--text" v-on="on">
                    Scroll Y Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <div class="mx-4 hidden-sm-and-down"></div>

              <v-menu transition="scroll-y-reverse-transition">
                <template v-slot:activator="{ on }">
                  <v-btn color="teal" class="ma-2 white--text" v-on="on">
                    Scroll Y Reverse Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" link>
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </div>
        </base-card>

      </v-col>

      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">
            Fade transition
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="text-center">
              <v-menu transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-btn dark color="purple" v-on="on">
                    Scale Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n">
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </base-card>

      </v-col>



      <v-col cols="12" sm="12" md="12">

        <base-card class="pa-2">
          <div slot="card-header">
            Custom Origin
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="text-center">
              <v-menu transition="scale-transition" origin="center center">
                <template v-slot:activator="{ on }">
                  <v-btn dark color="purple" v-on="on">
                    Scale Transition
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="n in 5" :key="n" @click="() => {}">
                    <v-list-item-title v-text="'Item ' + n"></v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </base-card>

      </v-col>

    </v-row>


  </v-container>

</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,BaseHeader
    }
  };
</script>


<!--====  End of TRANSITIONS  ====-->
